<app-nav></app-nav>

<main class="reset-password-page">
  <section class="auth-hero brand-section">
    <div class="hero-orb hero-orb-blue"></div>
    <div class="hero-orb hero-orb-green"></div>

    <div class="auth-card-shell">
      <div class="auth-card">

        @if (status === 'form') {
          <div class="state">
            <div class="badge-circle badge-brand">
              <mat-icon>lock_reset</mat-icon>
            </div>
            <span class="brand-eyebrow">Reset password</span>
            <h1>Pick a new password.</h1>
            <p class="brand-lede">
              Choose something at least 8 characters with an uppercase letter,
              a lowercase letter, a number, and a special character.
            </p>

            <form class="auth-form" (ngSubmit)="resetPassword()">
              <mat-form-field appearance="outline" class="full-width">
                <mat-label>New password</mat-label>
                <input
                  matInput
                  [type]="hidePassword ? 'password' : 'text'"
                  [(ngModel)]="password"
                  name="password"
                  required
                  minlength="8"
                  placeholder="Enter new password"
                />
                <button
                  mat-icon-button
                  matSuffix
                  type="button"
                  (click)="hidePassword = !hidePassword"
                  [attr.aria-label]="hidePassword ? 'Show password' : 'Hide password'"
                  [attr.aria-pressed]="!hidePassword"
                >
                  <mat-icon>{{ hidePassword ? 'visibility' : 'visibility_off' }}</mat-icon>
                </button>
              </mat-form-field>

              <mat-form-field appearance="outline" class="full-width">
                <mat-label>Confirm new password</mat-label>
                <input
                  matInput
                  [type]="hideConfirmPassword ? 'password' : 'text'"
                  [(ngModel)]="confirmPassword"
                  name="confirmPassword"
                  required
                  minlength="8"
                  placeholder="Confirm new password"
                />
                <button
                  mat-icon-button
                  matSuffix
                  type="button"
                  (click)="hideConfirmPassword = !hideConfirmPassword"
                  [attr.aria-label]="hideConfirmPassword ? 'Show password' : 'Hide password'"
                  [attr.aria-pressed]="!hideConfirmPassword"
                >
                  <mat-icon>{{ hideConfirmPassword ? 'visibility' : 'visibility_off' }}</mat-icon>
                </button>
              </mat-form-field>

              @if (errorMessage) {
                <div class="form-banner banner-error">
                  <mat-icon>error_outline</mat-icon>
                  <span>{{ errorMessage }}</span>
                </div>
              }

              <button type="submit" class="brand-btn brand-btn-primary brand-btn-large submit-button">
                <mat-icon>check</mat-icon>
                Reset password
              </button>
            </form>
          </div>
        }

        @if (status === 'submitting') {
          <div class="state">
            <div class="spinner-ring"><mat-spinner diameter="40" strokeWidth="3"></mat-spinner></div>
            <span class="brand-eyebrow">One sec</span>
            <h1>Saving your new password</h1>
            <p class="brand-lede">Hang tight — almost done.</p>
          </div>
        }

        @if (status === 'success') {
          <div class="state state-success">
            <div class="badge-circle badge-success">
              <mat-icon>check</mat-icon>
            </div>
            <span class="brand-eyebrow">Done</span>
            <h1>Password updated.</h1>
            <p class="brand-lede">
              You can sign in with your new password now. You can close this page
              and head back to the app.
            </p>
          </div>
        }

        @if (status === 'error') {
          <div class="state state-error">
            <div class="badge-circle badge-error">
              <mat-icon>priority_high</mat-icon>
            </div>
            <span class="brand-eyebrow">Reset failed</span>
            <h1>That didn't go through.</h1>
            <p class="brand-lede">{{ errorMessage }}</p>
            <p class="auth-helper">
              Request a new reset link from the app, or
              <a routerLink="/contact">contact support</a> if you keep hitting this.
            </p>
          </div>
        }

        @if (status === 'no-token') {
          <div class="state state-error">
            <div class="badge-circle badge-error">
              <mat-icon>link_off</mat-icon>
            </div>
            <span class="brand-eyebrow">Invalid link</span>
            <h1>This link is missing pieces.</h1>
            <p class="brand-lede">
              The reset token wasn't found in the URL. Use the original link from
              your email, or request a new one from the app.
            </p>
            <p class="auth-helper">
              Still stuck? <a routerLink="/contact">Get in touch</a>.
            </p>
          </div>
        }

      </div>
    </div>
  </section>
</main>

<app-footer></app-footer>
